<template>
  <div class="dashboard-overview">
    <h2>Welcome to Forms!</h2>
    <div v-show="forms.length==0">
      <md-empty-state
        :md-label="emptyStateLabelText"
        :md-description="emptyStateDescriptionText"
      />
      <md-content class="button-container">
        <router-link to="/forms/create">
          <md-button class="full-width md-raised md-dense" :md-ripple="false">New Form</md-button>
        </router-link>
      </md-content>
    </div>
    <div v-show="forms.length>0" class="form-table-container">
      <p>
        Below you can see a list of all your form endpoints.
        Click on one to look at in detail, learn how connect it to your web forms and how to view and export submissions.
      </p>
      <br>
      <h4>My Forms</h4>
      <md-table v-model="tableSource" md-sort="name" md-sort-order="asc">
        <md-table-row slot="md-table-row" slot-scope="{ item }" @click="showFormDetailView(item)">
          <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
          <md-table-cell md-label="Archived" md-sort-by="archived">{{ item.archived }}</md-table-cell>
          <md-table-cell md-label="Active After" md-sort-by="active_from">{{ item.active_from || '-'}}</md-table-cell>
          <md-table-cell md-label="Active Until" md-sort-by="active_to">{{ item.active_to || '-'}}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DashboardOverview',
  data () {
    return {
      tableSource: []
    }
  },
  mounted () {
    this.tableSource = this.forms.map((f) => JSON.parse(JSON.stringify(f)))
  },
  watch: {
    forms (newValue) {
      this.tableSource = newValue.map((f) => JSON.parse(JSON.stringify(f)))
    }
  },
  computed: {
    forms () {
      return this.$store.getters['forms']
    },
    emptyStateLabelText () {
      return 'You don\'t have any forms yet.'
    },
    emptyStateDescriptionText () {
      return 'Create your first form endpoint by pressing the button belown :)'
    }
  },
  methods: {
    showFormDetailView (form) {
      const path = `/forms/${form.id}`
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">
 @import '../../assets/theme.scss';

.dashboard-overview {
  text-align: left;

  button.md-button.full-width.md-raised.md-dense.md-theme-default {
    box-shadow: none;
    margin: 0;
    padding: 16px 24px;
    border-radius: 10px;
    background-color: whitesmoke;
    text-decoration: none !important;
    line-height: 42px;
    height: 42px;
  }
  button.md-button.full-width.md-raised.md-dense.md-theme-default:hover {
    background-color: $primary !important;
    color: white !important;
  }
  .md-card.md-table {
    margin-left: 0;
    margin-right: 0;
  }
  .md-table-row:hover {
    cursor: pointer;
  }
  .md-content.button-container {
    width: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/DashboardOverview.vue